import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const section = css`
  padding: ${spacing(0, 2)};
`
export const drawerSection = css`
  &:last-child {
    margin-block-end: 0;
  }

  &:last-child .${section} {
    padding-block-end: ${spacing(2)};
  }
`

export const sectionItem = css`
  padding: ${spacing(1, 0)};
  box-sizing: border-box;
  min-block-size: 56px;
  align-content: center;
`
